<app-dialog
  [headerLabel]="headerLabel"
  [dialogType]="dialogType"
  [primaryActionText]="confirmLabel"
  [secondaryActionText]="secondaryButtonText"
  customClass="payments-dialog"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="primaryActionTapped"
  [secondaryActionTapped]="secondaryActionTapped"
  [dismissActionTapped]="dismissActionTapped"
  (onPrimaryAction)="onConfirmDialog()"
  (onSecondaryAction)="onSecondaryAction.emit()"
  (onDialogClose)="onCancel.emit()"
>
  <div id="common-payments-dialog">
    <div class="content">
      <p class="content-row" [innerHTML]="description | safe: 'html'"></p>

      <app-checkmark-list
        class="content-row checkmark-list"
        [items]="listItems"
      >
      </app-checkmark-list>

      <p *ngIf="importantNote" class="content-row">
        <strong>
          {{ 'DIALOG.PAYMENTS.NOTE.LABEL' | translate }}
        </strong>
        {{ importantNote }}
      </p>

      <p *ngIf="tip" class="content-row">
        <strong>
          {{ 'DIALOG.PAYMENTS.TIP.LABEL' | translate }}
        </strong>
        {{ tip }}
      </p>

      <button
        type="button"
        *ngIf="learnMoreUrl"
        class="learn-more-button content-row"
        (click)="onLearnMore()"
      >
        {{ 'ACTION.LEARN_MORE' | translate }}
      </button>
    </div>
  </div>
</app-dialog>
